import { render, staticRenderFns } from "./HistorialImportaciones.vue?vue&type=template&id=55ed37be&scoped=true&"
import script from "./HistorialImportaciones.vue?vue&type=script&lang=js&"
export * from "./HistorialImportaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed37be",
  null
  
)

export default component.exports